export default __webpack_public_path__ + "static/media/add-user.b06f0fbc.svg";